import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useMemo } from 'react';
import { isDark } from '../common/utils';
import styles from './skeleton.module.scss';
const SkeletonRow = ({ id, width, animate, rowHeight, disableAnimation }) => {
    const isDarkMode = useMemo(() => isDark(), []);
    const skeletonRowClass = useMemo(() => classNames(styles.row, 'rc-skeleton-row', {
        [styles.animate]: animate,
        [styles.disable_animation]: disableAnimation,
        [styles.dark]: isDarkMode,
    }), [disableAnimation, isDarkMode]);
    const rowStyle = useMemo(() => ({
        '--height': `${rowHeight}px`,
    }), [rowHeight]);
    return (_jsx("span", { className: skeletonRowClass, style: { width: `${width}px`, ...rowStyle } }, id));
};
export { SkeletonRow };
